module.exports = __webpack_public_path__ + "static/media/Gallery-21.a634a061.jpg";